export default name => {
  name = name.toUpperCase()
  const RECEIVED = `${name}_RECEIVED`
  const UPDATED = `${name}_UPDATED`
  const ADDED = `${name}_ADDED`
  const REMOVED = `${name}_REMOVED`

  return (state = {}, { type, payload }) => {
    if (type === RECEIVED) {
      const copy = Object.assign({}, state)
      for (const key in payload) {
        copy[key] = Object.assign({}, payload[key])
      }
      return copy
    }
    if (type === UPDATED || type === ADDED) {
      const existing = state[payload.id]
      return Object.assign({}, state, {
        [payload.id]: Object.assign({}, existing, payload)
      })
    }
    if (type === REMOVED) {
      const copy = Object.assign({}, state)
      delete copy[payload]
      return copy
    }
    return state
  }
}
